import React, { createContext, useEffect, useState } from "react";
import OneSignal from "react-onesignal";
// ================= APP CONTEXT =================

let oneSignalInitialized = false;
let oneSignalInitializing = false;
const AppContext = createContext();

export const AppProvider = ({ children }) => {


  useEffect(() => {
    const initializeOneSignal = async () => {

      if (oneSignalInitialized || oneSignalInitializing) {
        return;
      }

      oneSignalInitializing = true;

      try {
        const oneSignalAppId =
          window.location.hostname === "localhost"
            ? "c9d6d434-b856-4c8a-8ae4-ce2f7fb94c55"
            : "37a571c0-f8f6-42d5-afad-d9055a3fab03";

   await OneSignal.init({
  appId: oneSignalAppId,
  allowLocalhostAsSecureOrigin: true,
});

oneSignalInitialized = true;

console.log("OneSignal initialized successfully");

setTimeout(async () => {
  try {
    if (!OneSignal.Notifications.permission) {
      await OneSignal.Slidedown.promptPush();
      console.log("OneSignal subscription popup shown");
    }
  } catch (error) {
    console.error("OneSignal popup error:", error);
  }
}, 2000);

      } catch (error) {

        // Ignore duplicate initialization error
        if (error?.message?.includes("SDK already initialized")) {
          oneSignalInitialized = true;
          console.log("OneSignal was already initialized.");
        } else {
          console.error("OneSignal initialization failed:", error);
        }

      } finally {
        oneSignalInitializing = false;
      }
    };

    initializeOneSignal();
  }, []);
  // ================= BASIC STATE =================
const loginWorkerToOneSignal = async (workerId) => {
  try {
    if (!workerId) {
      console.error("Worker OneSignal login failed: Worker ID missing");
      return false;
    }

    if (!oneSignalInitialized) {
      console.log("OneSignal is not initialized yet. Waiting...");

      let attempts = 0;

      while (!oneSignalInitialized && attempts < 50) {
        await new Promise(resolve => setTimeout(resolve, 200));
        attempts++;
      }
    }

    if (!oneSignalInitialized) {
      console.error("OneSignal initialization timeout");
      return false;
    }

    const externalId = `worker_${workerId}`;

    await OneSignal.login(externalId);

    console.log(
      "Worker successfully logged into OneSignal:",
      externalId
    );

    return true;

  } catch (error) {
    console.error("Worker OneSignal login failed:", error);
    return false;
  }
};

const loginCustomerToOneSignal = async (customerId) => {

    try {

        if (!customerId) {
            console.error(
                "Customer OneSignal login failed: Customer ID missing"
            );
            return false;
        }

        if (!oneSignalInitialized) {

            console.log(
                "OneSignal is not initialized yet. Waiting..."
            );

            let attempts = 0;

            while (
                !oneSignalInitialized &&
                attempts < 50
            ) {

                await new Promise(
                    resolve => setTimeout(resolve, 200)
                );

                attempts++;
            }
        }

        if (!oneSignalInitialized) {

            console.error(
                "OneSignal initialization timeout"
            );

            return false;
        }

        const externalId = `customer_${customerId}`;

        await OneSignal.login(externalId);

        console.log(
            "Customer successfully logged into OneSignal:",
            externalId
        );

        return true;

    } catch (error) {

        console.error(
            "Customer OneSignal login failed:",
            error
        );

        return false;
    }
};
  // For Development
  // const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlForFile, setBaseUrlForFile] = useState("http://127.0.0.1:8000/storage");

  // For Production
  // const [baseUrl, setBaseUrl] = useState("https://workhub.btsportfolio2026.com/backend/public/api");
  // const [baseUrlForFile, setBaseUrlForFile] = useState("https://workhub.btsportfolio2026.com/backend/public/storage");

  const [baseUrl, setBaseUrl] = useState("https://picks4tips.com/backend/public/api");
  const [baseUrlForFile, setBaseUrlForFile] = useState("https://picks4tips.com/backend/public/storage");

  const [loggedInCustomer, setLoggedInCustomer] = useState(null);
  const [selectedCategoryForProducts, setSelectedCategoryForProducts] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [kycStatus, setKycStatus] = useState(null);
  const [workerProfile, setWorkerProfile] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);

  // ================= SIMPLE REGEX =================

  // Only letters and spaces
  const fullNameRegex = /^[A-Za-z ]+$/;

  // Simple email regex
  const emailRegex = /^\S+@\S+\.\S+$/;

  // Password minimum 6 characters
  const passwordRegex = /^.{6,}$/;

  // Phone number only digits, minimum 10 digits
  const phoneNoRegex = /^(\+?\d{1,4})?\d{10,}$/;

  // City only letters and spaces
  const cityRegex = /^[A-Za-z ]+$/;



  // SNS
  const ssnRegex = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/;
  // Job Title
  const jobTitleRegex = /^[A-Za-z0-9\s.,()&'-]{5,100}$/;

  // Description
  const descriptionRegex = /^.{20,1000}$/;

  // Budget
  const budgetRegex = /^[1-9]\d*$/;

  // Address
  const addressRegex = /^[A-Za-z0-9\s,#./()-]{10,255}$/;

  // ================= VALIDATION FUNCTION =================

  const RegExpChecker = (type, input) => {
    switch (type) {

      case "fullName":
        if (!fullNameRegex.test(input)) {
          return {
            fullName: "Name should contain only letters.",
          };
        }
        return { fullName: "" };

      case "email":
        if (!emailRegex.test(input)) {
          return {
            email: "Please enter a valid email.",
          };
        }
        return { email: "" };

      case "password":
        if (!passwordRegex.test(input)) {
          return {
            password: "Password must be at least 6 characters.",
          };
        }
        return { password: "" };

      case "phone":
        if (!phoneNoRegex.test(input)) {
          return {
            phone: "Phone number must contain at least 10 digits.",
          };
        }
        return { phone: "" };

      case "city":
        if (!cityRegex.test(input)) {
          return {
            city: "City name should contain only letters.",
          };
        }
        return { city: "" };



      case "ssn":
        if (!ssnRegex.test(input)) {
          return {
            ssn: "Invalid SSN. Please enter in this format: 987-65-4321",
          };
        }
        return { ssn: "" };

      case "jobTitle":
        if (!jobTitleRegex.test(input)) {
          return {
            jobTitle: "Job title must be between 5 and 100 characters."
          };
        }
        return { jobTitle: "" };

      case "description":
        if (!descriptionRegex.test(input)) {
          return {
            description: "Description must be at least 20 characters."
          };
        }
        return { description: "" };

      case "budget":
        if (!budgetRegex.test(input)) {
          return {
            budget: "Budget must be greater than 0."
          };
        }
        return { budget: "" };

      case "address":
        if (!addressRegex.test(input)) {
          return {
            address: "Please enter a valid address."
          };
        }
        return { address: "" };

      default:
        return {};
    }
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        baseUrlForFile,

        authToken,
        setAuthToken,

        loggedInCustomer,
        setLoggedInCustomer,

        selectedCategoryForProducts,
        setSelectedCategoryForProducts,

        RegExpChecker,

        kycStatus,
        setKycStatus,
        workerProfile,
        setWorkerProfile,

        dashboardData,
        setDashboardData,

         loginWorkerToOneSignal,
    loginCustomerToOneSignal,

      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;